import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { Modal, Button, Dropdown, Input, Image } from 'semantic-ui-react'
import PropTypes from 'prop-types'
import styles from './UploadToJwStyles'
import thumb from 'Images/thumb-placeholder.png'
import Capitalize from 'Lib/Capitalize'
import { path } from 'ramda'
import VideoIntegration from 'Redux/VideoIntegrationRedux'
import Alert from 'Components/Alert'

class UploadToJw extends PureComponent {

  static defaultProps = {
    icon: 'cloud upload',
    menuItemText: 'Upload',
    title: 'Publish video',
    video: {},
    onPublishComplete: () => {},
    onCancel: () => {}
  }

  static propTypes = {
    icon: PropTypes.string,
    menuItemText: PropTypes.string,
    title: PropTypes.string,
    video: PropTypes.object.isRequired,
    onPublishComplete: PropTypes.func,
    onCancel: PropTypes.func
  }

  constructor(props) {
    super(props)

    this.state = {
      showModal: false,
      title: props.video.title,
      description: props.video.description
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.pushData !== prevProps.pushData) {
      this.setState({ showModal: false })
      this.props.onPublishComplete(this.props.pushData)
    }
  }

  onActionStart = (e) => {
    e.stopPropagation()
    this.setState({ showModal: true })
  }

  onPublish = () => {
    const params = {
      title: this.state.title,
      description: this.state.description
    }
    this.props.videoJwPushRequest(this.props.video.id, params)
  }

  onCancel = () => {
    this.setState({ showModal: false })
    this.props.onCancel()
  }

  onChange = event => {
    const { name, value } = event.target
    this.setState({[name]: value})
  }

  render () {
    const video = this.props.video
    const jwApiKey = path(['settings', 'jwApiKey'], this.props.userData)
    const jwApiSecret = path(['settings', 'jwApiSecret'], this.props.userData)

    const item = (
      <Modal dimmer="blurring"
             trigger={
              <Dropdown.Item icon={this.props.icon}
                             text={this.props.menuItemText}
                             onClick={this.onActionStart}/>
             }
             open={this.state.showModal}>
          <Modal.Header>{this.props.title}</Modal.Header>
          <Modal.Content className={styles.modalContent}>
            <Alert color='red' messages={this.props.error} />
            <Modal.Description className={styles.videoDescriptionModal}>
              <Image wrapped
                     className={styles.videoImageModal}
                     size='small'
                     src={video.posterUrl || thumb}
                     alt={video.title} />
              <div>
                <div className={styles.title}>{Capitalize(video.title)}</div>
                <div>
                  <span className={styles.user}>{video.username}</span>
                  <span className={styles.dot}>&#183;</span>
                  <span className={styles.date}>{video.createdAt}</span>
                </div>
              </div>
            </Modal.Description>
            <div className={styles.uploadParameters}>
              <div className={styles.uploadParameterInput}>
                <div className={styles.label}>Title</div>
                <Input name="title"
                       value={this.state.title}
                       onChange={this.onChange} />
              </div>
              <div className={styles.uploadParameterInput}>
                <div className={styles.label}>Description</div>
                <Input name="description"
                       value={this.state.description}
                       onChange={this.onChange} />
              </div>
            </div>
          </Modal.Content>
          <Modal.Actions>
            <Button onClick={this.onCancel}>
              Cancel
            </Button>
            <Button
              icon='upload'
              labelPosition='left'
              content='Publish'
              primary
              loading={this.props.fetching}
              onClick={this.onPublish}
            />
          </Modal.Actions>
        </Modal>
    )

    return (jwApiKey && jwApiSecret) ? item : null
  }
}

const mapStateToProps = (state) => ({
  userData: state.auth.userData,
  fetching: state.videoIntegrations.jwPushFetching,
  error: state.videoIntegrations.jwPushError,
  pushData: state.videoIntegrations.jwPushData
})

const mapDispatchToProps = (dispatch) => ({
  videoJwPushRequest: (id, params) =>
    dispatch(VideoIntegration.videoJwPushRequest(id, params)),
})

export default connect(mapStateToProps, mapDispatchToProps)(UploadToJw)



// WEBPACK FOOTER //
// ./src/Components/UploadToDrive/UploadToJw.js